/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CkRichTextSectionFragment } from "@cosmos/hygraph-schema";
import { BackgroundContainer, ResponsiveContainer, SectionContainer, CosmosRichText } from "@components/elements";
import { richTextContentStyles } from "./rich-text.section.styles";
import { RichTextButtons, RichTextHeading, RichTextStack } from "./rich-text.section.common";

export const CkRichTextSection = ({
	config,
	ckContent,
	centered = false,
	wide = false,
	centeredButton = false,
	buttons = [],
}: CkRichTextSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(ckContent || buttons?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer className="ck-rich-text-section" disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<RichTextStack wide={wide} centered={centered || false}>
						{validHeading ? <RichTextHeading heading={config?.heading} centered={centered || false} /> : null}
						{validContent ? (
							<>
								<div className={richTextContentStyles}>
									<CosmosRichText html={ckContent} />
								</div>
								<RichTextButtons buttons={buttons} centeredButton={centeredButton} component="CkRichTextSection" />
							</>
						) : null}
					</RichTextStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
